import React from "react";
import { FormField } from "../Field/FormField";
import { TextareaField as Textarea } from "../Field/TextareaField";
import { FieldProps } from "./TextField";

export const TextareaField = ({ name, field }: FieldProps) => {
    return (
        <FormField label={field.label} name={name}>
            <Textarea />
        </FormField>
    );
};
